import {
  AppBar,
  Card,
  CardContent,
  Grid,
  Tab,
  Tabs,
  Typography,
  LinearProgress
} from "@material-ui/core";
import CustomChip from "components/CustomChip/CustomChip.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { GetUserId, GetUserToken, GetUserKey } from "helpers/UserHelper";
import { DeleteTodo, Todo } from "queries/todo/mutations";
import { GetUserTodos } from "queries/todo/queries";
import React from "react";
import { compose, graphql, Query } from "react-apollo";
import { showSnack } from "reducers/NotificationReducer";
import store from "store";
import TodoDialog from "./components/TodoDialog.jsx";
import UserTodosCurrent from "./components/UserTodosCurrent.jsx";
import UserTodosDone from "./components/UserTodosDone.jsx";
import UserTodosAssigned from "./components/UserTodosAssigned.jsx";

const tabStyle = {
  color: "#6c5cab",
  borderBottom: "2px solid"
};

class UserTodos extends React.Component {
  state = {
    tab: 0,
    todosInitiated: false,
    currentTodos: [],
    doneTodos: [],
    assignedTodos: [],
    openTodoDialog: false,
    selectedTodo: null
  };

  tabs = ["Own", "Done"];

  checkAssistantActive() {
    return GetUserKey("userType") === "6" ? true : false;
  }

  componentDidMount() {
    if (this.checkAssistantActive()) {
      this.tabs.unshift("Assigned to you");
    }
  }

  handelCloseTodoDialog = () => {
    this.setState({ openTodoDialog: false, selectedTodo: null });
  };

  handelOpenTodoDialog = (todo = null) => {
    this.setState({ selectedTodo: todo, openTodoDialog: true });
  };

  handleChangeTab = (event, value) => {
    this.setState({ tab: value });
  };

  handleTodoDoneClick = id => {
    let currentTodos = [...this.state.currentTodos];
    let doneTodos = [...this.state.doneTodos];

    let todo = currentTodos.find(t => t.id === id);
    let todoIndex = currentTodos.findIndex(t => t.id === id);

    if (todo) {
      currentTodos[todoIndex].loadingAction = true;
      this.setState({ currentTodos: currentTodos });

      this.ExecuteTodoMutation(todo, 1, resp => {
        store.dispatch(
          showSnack({
            message: "Todo Marked as done",
            color: "success"
          })
        );
        todo.loadingAction = false;
        doneTodos.unshift(todo);
        currentTodos = currentTodos.filter(t => t.id !== id);
        this.setState({ currentTodos: currentTodos, doneTodos: doneTodos });
      });
    }
  };

  handleTodoMoveToCurrent = id => {
    var currentTodos = [...this.state.currentTodos];
    var doneTodos = [...this.state.doneTodos];

    var todo = doneTodos.find(t => t.id === id);
    let todoIndex = doneTodos.findIndex(t => t.id === id);

    if (todo) {
      doneTodos[todoIndex].loadingAction = true;
      this.setState({ doneTodos: doneTodos });

      this.ExecuteTodoMutation(todo, 0, resp => {
        store.dispatch(
          showSnack({
            message: "Todo Marked as not done",
            color: "success"
          })
        );
        todo.loadingAction = false;
        currentTodos.unshift(todo);
        doneTodos = doneTodos.filter(t => t.id !== id);
        this.setState({ currentTodos: currentTodos, doneTodos: doneTodos });
      });
    }
  };

  handleTodoAssignedDone = id => {
    var assignedTodos = [...this.state.assignedTodos];

    var todo = assignedTodos.find(t => t.id === id);
    let todoIndex = assignedTodos.findIndex(t => t.id === id);

    if (todo) {
      assignedTodos[todoIndex].loadingAction = true;
      this.setState({ assignedTodos: assignedTodos });

      this.ExecuteTodoMutation(todo, 2, resp => {
        store.dispatch(
          showSnack({
            message: "Assigned To Do Marked as done",
            color: "success"
          })
        );

        todo.loadingAction = false;
        assignedTodos = assignedTodos.filter(t => t.id !== id);
        this.setState({ assignedTodos: assignedTodos });
      });
    }
  };

  ExecuteTodoMutation(todo, done, callback) {
    const input = {
      todoId: todo.id,
      userId: GetUserId(),
      token: GetUserToken(),
      title: todo.title,
      desc: todo.description,
      assistantId: todo.assigned_userId,
      clientId: todo.client_id,
      done: done
    };

    this.props
      .Todo({
        variables: {
          input
        }
      })
      .then(resp => {
        callback(resp);
      })
      .catch(error => {
        console.log("err", error);
      });
  }

  todoAdded = todo => {
    let currentTodos = [...this.state.currentTodos];
    currentTodos.unshift({ ...todo, loadingAction: false });
    this.setState({ currentTodos: currentTodos });
  };

  todoEdited = todo => {
    let currentTodos = [...this.state.currentTodos];
    let todoIndex = currentTodos.findIndex(t => t.id === todo.id);
    currentTodos[todoIndex] = todo;
    this.setState({ currentTodos: currentTodos });
  };

  deleteTodo = (id, type) => {
    var todos = [...this.state[type]];
    const todo = todos.find(t => t.id === id);
    let todoIndex = todos.findIndex(t => t.id === id);

    if (todo) {
      todos[todoIndex].loadingAction = true;
      this.setState({ [type]: todos });

      this.props
        .DeleteTodo({
          variables: {
            input: {
              todoId: todo.id,
              userId: GetUserId(),
              token: GetUserToken()
            }
          }
        })
        .then(resp => {
          store.dispatch(
            showSnack({
              message: "Todo Delete",
              color: "danger"
            })
          );
          todos = todos.filter(t => t.id !== id);
          this.setState({ [type]: todos });
        })
        .catch(error => {
          console.log("err", error);
        });
    }
  };

  render() {
    const { tab } = this.state;
    return (
      <Grid container>
        <GridItem xs={12} sm={12} md={10} style={{flexBasis: "100%", maxWidth: "100%", margin: 'auto' }}>
          <Card>
            <CardContent>
              <div style={{ marginBottom: "35px" }}>
                <Typography variant="headline" className="centerCell">
                  To Do
                </Typography>

                <div
                  style={{
                    borderBottom: "1px solid #cccccc69",
                    margin: "5px auto",
                    width: "25%"
                  }}
                />
              </div>
              <Query
                query={GetUserTodos}
                variables={{
                  userId: GetUserId(),
                  token: GetUserToken(),
                  done: 0
                }}
                fetchPolicy="network-only"
              >
                {({ loading, error, data, refetch }) => {
                  if (loading) {
                    return <LinearProgress />;
                  }
                  if (!this.state.todosInitiated) {
                    let UserTodos = [...data.UserTodos];

                    let doneTodos = UserTodos.filter(
                      u =>
                        u.done === true &&
                        u.assigned_userId !== parseInt(GetUserId(), 10)
                    );
                    doneTodos = doneTodos.map(u => {
                      return { ...u, loadingAction: false };
                    });

                    let currentTodos = UserTodos.filter(
                      u =>
                        u.done === false &&
                        u.assigned_userId !== parseInt(GetUserId(), 10)
                    );
                    currentTodos = currentTodos.map(u => {
                      return { ...u, loadingAction: false };
                    });

                    let assignedTodos = UserTodos.filter(
                      u =>
                        u.assigned_userId === parseInt(GetUserId(), 10) &&
                        !u.todo_assigned_done
                    );
                    assignedTodos = assignedTodos.map(u => {
                      return { ...u, loadingAction: false };
                    });

                    this.setState({
                      currentTodos: currentTodos,
                      doneTodos: doneTodos,
                      assignedTodos: assignedTodos,
                      todosInitiated: true
                    });
                  }
                  return (
                    <React.Fragment>
                      <AppBar
                        position="static"
                        color="default"
                        style={{ marginBottom: "20px" }}
                      >
                        <Tabs
                          tab={tab}
                          onChange={this.handleChangeTab}
                          indicatorColor="primary"
                          textColor="secondary"
                          scrollable
                          scrollButtons="auto"
                        >
                          {this.tabs.map((t, i) => {
                            return (
                              <Tab
                                label={t}
                                style={i === tab ? tabStyle : {}}
                                key={t}
                              />
                            );
                          })}
                        </Tabs>
                      </AppBar>

                      {tab === 0 && this.checkAssistantActive() ? (
                        <UserTodosAssigned
                          todos={this.state.assignedTodos}
                          handleDoneToggle={this.handleTodoAssignedDone}
                        />
                      ) : null}

                      {(tab === 0 && !this.checkAssistantActive()) ||
                      (tab === 1 && this.checkAssistantActive()) ? (
                        <React.Fragment>
                          <CustomChip
                            text="Add Todo"
                            icon="add"
                            clicked={this.handelOpenTodoDialog}
                            style={{ marginBottom: "25px" }}
                          />

                          <UserTodosCurrent
                            todos={this.state.currentTodos}
                            handleDoneToggle={this.handleTodoDoneClick}
                            handleDelete={id =>
                              this.deleteTodo(id, "currentTodos")
                            }
                            handleEdit={todo => this.handelOpenTodoDialog(todo)}
                          />
                        </React.Fragment>
                      ) : null}

                      {(tab === 1 && !this.checkAssistantActive()) ||
                      (tab === 2 && this.checkAssistantActive()) ? (
                        <UserTodosDone
                          todos={this.state.doneTodos}
                          handleDoneToggle={this.handleTodoMoveToCurrent}
                          handleDelete={id => this.deleteTodo(id, "doneTodos")}
                        />
                      ) : null}
                    </React.Fragment>
                  );
                }}
              </Query>
            </CardContent>
          </Card>
        </GridItem>
        {this.state.openTodoDialog ? (
          <TodoDialog
            open={true}
            closeDialog={this.handelCloseTodoDialog}
            todoAdded={resp => this.todoAdded(resp)}
            todoEdited={resp => this.todoEdited(resp)}
            todo={this.state.selectedTodo}
          />
        ) : null}
      </Grid>
    );
  }
}

UserTodos = compose(
  graphql(Todo, { name: "Todo" }),
  graphql(DeleteTodo, { name: "DeleteTodo" })
)(UserTodos);

export default UserTodos;



// WEBPACK FOOTER //
// ./src/views/Todos/UserTodos.jsx